import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getSearchPollGroup = (searchKey) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.SEARCH_POLL_GROUP(searchKey)
  );
};

export default getSearchPollGroup;
